<template>
    <div class="box">
      <div class="zhongduan-setting-box">
        <div class="tile-box">终端设置--{{ terminalName }}</div>
        <ul class="ul-box-for">
          <li class="name-box"><span class="item-name-box1">名称:{{ this.username }}</span>|</li>
          <li v-for="item in topList" class="name-box" :key="item">
            <span class="item-name-box" @click="topNmaeClick(item)">{{ item.name }}</span> |
          </li>
        </ul>
        <div>
          <!-- <familyNumber class="familyNumber-box" v-if="itemName == '亲情号码'"></familyNumber> -->
          <component :is="terminalValue" :key="timestamp" ></component>
        </div>
      </div>
    </div>
</template>

<script>
import familyNumber from './group/family-number/index.vue' // 亲情号码
import whiteList from './group/white-list/index.vue' // 白名单
import alarmClock from './group/alarm-clock/index.vue' // 闹钟设置
import mute from './group/mute/index.vue' // 静音设置
import timing from './group/timing/index.vue' // 定时跟踪设置
import dormancy from './group/dormancy/index.vue' // 休眠设置
import weilansetting from './group/weilansetting/index.vue' // 围栏设置
import sossetting from './group/sos-setting/index.vue' // 围栏设置
import healthSettings from './group/health-settings/index.vue' // 健康设置
import activate from './group/activate/index.vue' // 围栏设置
export default {
    components: {
      familyNumber,
      whiteList,
      alarmClock,
      mute,
      timing,
      dormancy,
      weilansetting,
      sossetting,
      healthSettings,
      activate
    },
    data() {
        return {
          username:'',
          topList: [
            {
              name: '亲情号码',
              value: 'familyNumber',
            },
            {
              name: '白名单',
              value: 'whiteList',
            },
            {
              name: 'SOS',
              value: 'sossetting',
            },
            {
              name: '围栏设置',
              value: 'weilansetting',
            },
            {
              name: '上课禁用',
              value: 'mute',
            },
            {
              name: '闹钟设置',
              value: 'alarmClock',
            },
            {
              name: '休眠设置',
              value: 'dormancy',
            },
            {
              name: '定时跟踪设置',
              value: 'timing',
            },
            {
              name: '健康设置',
              value: 'healthSettings',
            },
            {
              name: '激活',
              value: 'activate',
            }
          ],
          terminalValue: 'familyNumber',
          terminalName: '亲情号码',
          timestamp: new Date().getTime(),

        };
    },
    created() {
      window.document.title = '终端设置'
    },
    mounted() {
     this.username = this.$route.query.name

    },
    methods: {
         topNmaeClick (item) {
          console.log(item,11111111111);
          this.terminalValue = item.value
          this.terminalName = item.name
          this.timestamp = new Date().getTime(),
          console.log(this.timestamp,'//////////////',this.terminalValue,this.terminalName);
        }
    },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  padding-top: 30px;
}
.zhongduan-setting-box {
  margin-left: 25%;
  width: 70%;
  .tile-box {
    font-size: 18px;
    padding: 5px 0px;
    border-bottom: 1px solid #c5ddf6;
  }
  .ul-box-for {
    margin-top: 20px;
  } 
  .name-box {
    display: inline-block;
    padding-top: 10px; 
    font-size: 14px;
    cursor: pointer;
    .item-name-box1 {
      padding-right:  8px;
      font-size: 15px;
      
    }
    .item-name-box {
      padding: 0px 8px;
      color: #2E6EBD;
      font-size: 15px;
    }
  }
}
</style>
